<template>
  <div class="sidebar-wrapper">
    <nav
      :class="{ sidebar: true, sidebarStatic, sidebarOpened }"
      @mouseenter="sidebarMouseEnter"
      @mouseleave="sidebarMouseLeave"
    >
      <!-- HEADER LOGO -->
      <header class="logo">
        <router-link to="/app/dashboard" title="Dashboard">
          <div class="logo-container">
            <!-- Tampilkan logo lengkap saat sidebar terbuka (Hover/Static) -->
            <img 
              v-if="sidebarOpened || sidebarStatic" 
              :src="require('./logo_new_v3.png')" 
              alt="Logo Full" 
              class="img-logo-full"
            />
            <!-- Tampilkan logo ikon saja saat sidebar dalam posisi tertutup -->
            <img 
              v-else 
              :src="require('./logo_tanpa_tulisan.png')" 
              alt="Logo Icon" 
              class="img-logo-icon"
            />
          </div>
        </router-link>
      </header>

      <!-- ROLE: SUPERUSER -->
      <ul class="nav" v-if="user.role === 'superuser'">
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />
        
        <NavLink :activeItem="activeItem" header="Setting User" link="/app/setting" iconName="fa fa-users" index="setting" icon-img="sidebar/Outline/User.svg" :childrenLinks="[
          { header: 'User', link: '/app/setting/user' },
          { header: 'Tandatangan', link: '/app/setting/tandatangan' },
        ]" />

        <NavLink :activeItem="activeItem" header="Master Data" link="/app/master" iconName="flaticon-shopping-bag" icon-img="sidebar/Outline/Bank.svg" index="master" :childrenLinks="[
          { header: 'Jenis Proyek', link: '/app/master/jenis-proyek' },
          { header: 'Jenis Permohonan', link: '/app/master/jenis-permohonan' },
          { header: 'Klasifikasi Pemohon', link: '/app/master/klasifikasi-pemohon' },
          { header: 'Risiko', link: '/app/master/risiko' },
          { header: 'Skala Usaha', link: '/app/master/skala-usaha' },
          { header: 'Lokasi', link: '/app/master/lokasi' },
          { header: 'KBLI', link: '/app/master/kbli' },
          { header: 'Dinas/Pemda', link: '/app/master/dinas-pemda' },
          { header: 'Kementerian/Lembaga', link: '/app/master/kementerian' },
          { header: 'Kop Surat', link: '/app/master/kop-surat' },
          { header: 'Capaian Target PNBP', link: '/app/master/capaian-target-pnbp' },
        ]" />

        <h5 class="navTitle">Perizinan Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Perizinan Baru" link="/app/perizinan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perizinan-baru" isHeader />
        <NavLink :activeItem="activeItem" header="Penambahan KBLI" link="/app/penambahan-kbli" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="penambahan-kbli" isHeader />
        <NavLink :activeItem="activeItem" header="Notifikasi Izin Lokasi" link="/app/notifikasi-izin-lokasi" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="notifikasi-izin-lokasi" isHeader />

        <h5 class="navTitle">Perizinan Non Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Pemerintah" link="/app/nonberusaha/pemerintah" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-pemerintah" isHeader />
        <NavLink :activeItem="activeItem" header="Swasta" link="/app/nonberusaha/swasta" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-swasta" isHeader />

        <h5 class="navTitle">Pemutakhiran</h5>
        <!-- <NavLink :activeItem="activeItem" header="Early Warning" link="/app/early-warning" iconName="flaticon-file" icon-img="sidebar/Outline/Document.svg" index="early-warning" :childrenLinks="[
          { header: 'Berusaha', link: '/app/early-warning/berusaha' },
          { header: 'Pemerintah', link: '/app/early-warning/pemerintah' },
          { header: 'Swasta', link: '/app/early-warning/swasta' },
        ]" /> -->
        <NavLink :activeItem="activeItem" header="Habis Masa Berlaku" link="/app/habis-masa-berlaku" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="habis-masa-berlaku" isHeader />
        <NavLink :activeItem="activeItem" header="Perubahan" link="/app/perubahan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perubahan" isHeader />
        <NavLink :activeItem="activeItem" header="Pembatalan" link="/app/pembatalan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="pembatalan" isHeader />
        <NavLink :activeItem="activeItem" header="Pencabutan" link="/app/pencabutan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="pencabutan" isHeader />

        <h5 class="navTitle">Pengendalian</h5>
        <NavLink :activeItem="activeItem" header="Penilaian Laporan Tahunan" link="/app/penilaian-laporan-tahunan" iconName="flaticon-search" index="penilaian-laporan-tahunan" icon-img="sidebar/Fill/Search.svg" isHeader class="custom-navlink" />
        
        <h5 class="navTitle">Lainnya</h5>
        <NavLink :activeItem="activeItem" header="Web Profile" link="/app/web" iconName="Stack" icon-img="sidebar/Outline/Stack.svg" index="web" isHeader :childrenLinks="[
          { header: 'Profile', link: '/app/web/profile' },
          { header: 'Slider', link: '/app/web/slider' },
          { header: 'Tentang', link: '/app/web/about' },
          { header: 'Perizinan', link: '/app/web/approval' },
          { header: 'Pengumuman', link: '/app/web/announcement' },
          { header: 'Lapor', link: '/app/web/report' },
          { header: 'Galeri', link: '/app/web/gallery' },
          { header: 'FAQ', link: '/app/web/faq' },
        ]" />
      </ul>

      <!-- ROLE: ADMIN_KKP -->
      <ul class="nav" v-else-if="user.role === 'admin_kkp'">
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />
        
        <h5 class="navTitle">Perizinan Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Perizinan Baru" link="/app/perizinan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perizinan-baru" isHeader />
        <NavLink :activeItem="activeItem" header="Penambahan KBLI" link="/app/penambahan-kbli" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="penambahan-kbli" isHeader />
        <NavLink :activeItem="activeItem" header="Notifikasi Izin Lokasi" link="/app/notifikasi-izin-lokasi" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="notifikasi-izin-lokasi" isHeader />

        <h5 class="navTitle">Perizinan Non Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Pemerintah" link="/app/nonberusaha/pemerintah" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-pemerintah" isHeader />
        <NavLink :activeItem="activeItem" header="Swasta" link="/app/nonberusaha/swasta" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-swasta" isHeader />
        
        <!-- <h5 class="navTitle">Pengendalian</h5>
        <NavLink :activeItem="activeItem" header="Laporan Tahunan" link="/app/penilaian-laporan-tahunan" iconName="flaticon-search" index="penilaian-laporan-tahunan" icon-img="sidebar/Fill/Search.svg" isHeader /> -->
      </ul>

      <!-- ROLE: ADMIN_UPT -->
      <ul class="nav" v-else-if="user.role === 'admin_upt'">
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />
        
        <h5 class="navTitle">Perizinan Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Perizinan Baru" link="/app/perizinan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perizinan-baru" isHeader />
        <NavLink :activeItem="activeItem" header="Penambahan KBLI" link="/app/penambahan-kbli" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="penambahan-kbli" isHeader />
        <NavLink :activeItem="activeItem" header="Notifikasi Izin Lokasi" link="/app/notifikasi-izin-lokasi" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="notifikasi-izin-lokasi" isHeader />

        <h5 class="navTitle">Perizinan Non Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Pemerintah" link="/app/nonberusaha/pemerintah" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-pemerintah" isHeader />
        <NavLink :activeItem="activeItem" header="Swasta" link="/app/nonberusaha/swasta" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-swasta" isHeader />
      </ul>

      <!-- ROLE: TIM_PENILAI_PUSAT & TIM_PENILAI_UPT -->
      <ul class="nav" v-else-if="user.role === 'tim_penilai_pusat' || user.role === 'tim_penilai_upt'">
        <!-- <h5 class="navTitle first">Pengendalian</h5>
        <NavLink :activeItem="activeItem" header="Penilaian Laporan Tahunan" link="/app/penilaian-laporan-tahunan" iconName="flaticon-search" index="penilaian-laporan-tahunan" icon-img="sidebar/Fill/Search.svg" isHeader class="custom-navlink" />
         -->
        <h5 class="navTitle">Perizinan</h5>
        <NavLink :activeItem="activeItem" header="Berusaha" link="/app/perizinan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perizinan-baru" isHeader />
        <NavLink :activeItem="activeItem" header="Non Berusaha" link="/app/nonberusaha" iconName="flaticon-file" icon-img="sidebar/Outline/Document.svg" index="nonberusaha" :childrenLinks="[
          { header: 'Pemerintah', link: '/app/nonberusaha/pemerintah' },
          { header: 'Swasta', link: '/app/nonberusaha/swasta' },
        ]" />
      </ul>

      <!-- ROLE: TIM_TEKNIS -->
      <ul class="nav" v-else-if="user.role === 'tim_teknis'">
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />

        <h5 class="navTitle">Perizinan Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Perizinan Baru" link="/app/perizinan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perizinan-baru" isHeader />
        <NavLink :activeItem="activeItem" header="Penambahan KBLI" link="/app/penambahan-kbli" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="penambahan-kbli" isHeader />
        <NavLink :activeItem="activeItem" header="Notifikasi Izin Lokasi" link="/app/notifikasi-izin-lokasi" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="notifikasi-izin-lokasi" isHeader />

        <h5 class="navTitle">Perizinan Non Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Pemerintah" link="/app/nonberusaha/pemerintah" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-pemerintah" isHeader />
        <NavLink :activeItem="activeItem" header="Swasta" link="/app/nonberusaha/swasta" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-swasta" isHeader />
      </ul>

      <!-- ROLE: TIM_TEKNIS_PEMUTAKHIRAN -->
      <ul class="nav" v-else-if="user.role === 'tim_teknis_pemutakhiran'">
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />

        <h5 class="navTitle">Perizinan Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Perizinan Baru" link="/app/perizinan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perizinan-baru" isHeader />
        <NavLink :activeItem="activeItem" header="Penambahan KBLI" link="/app/penambahan-kbli" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="penambahan-kbli" isHeader />
        <NavLink :activeItem="activeItem" header="Notifikasi Izin Lokasi" link="/app/notifikasi-izin-lokasi" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="notifikasi-izin-lokasi" isHeader />

        <h5 class="navTitle">Perizinan Non Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Pemerintah" link="/app/nonberusaha/pemerintah" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-pemerintah" isHeader />
        <NavLink :activeItem="activeItem" header="Swasta" link="/app/nonberusaha/swasta" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-swasta" isHeader />

        <h5 class="navTitle">Pemutakhiran</h5>
        <!-- <NavLink :activeItem="activeItem" header="Early Warning" link="/app/early-warning" iconName="flaticon-file" icon-img="sidebar/Outline/Document.svg" index="early-warning" :childrenLinks="[
          { header: 'Berusaha', link: '/app/early-warning/berusaha' },
          { header: 'Pemerintah', link: '/app/early-warning/pemerintah' },
          { header: 'Swasta', link: '/app/early-warning/swasta' },
        ]" /> -->
        <NavLink :activeItem="activeItem" header="Habis Masa Berlaku" link="/app/habis-masa-berlaku" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="habis-masa-berlaku" isHeader />
        <NavLink :activeItem="activeItem" header="Perubahan" link="/app/perubahan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perubahan" isHeader />
        <NavLink :activeItem="activeItem" header="Pembatalan" link="/app/pembatalan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="pembatalan" isHeader />
        <NavLink :activeItem="activeItem" header="Pencabutan" link="/app/pencabutan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="pencabutan" isHeader />
      </ul>

      <!-- ROLE: PIC_PEMUTAKHIRAN -->
      <ul class="nav" v-else-if="user.role === 'pic_pemutakhiran'">
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />

        <h5 class="navTitle">Perizinan Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Penambahan KBLI" link="/app/penambahan-kbli" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="penambahan-kbli" isHeader />
        <NavLink :activeItem="activeItem" header="Notifikasi Izin Lokasi" link="/app/notifikasi-izin-lokasi" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="notifikasi-izin-lokasi" isHeader />

        <h5 class="navTitle">Pemutakhiran</h5>
        <NavLink :activeItem="activeItem" header="Habis Masa Berlaku" link="/app/habis-masa-berlaku" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="habis-masa-berlaku" isHeader />
        <NavLink :activeItem="activeItem" header="Perubahan" link="/app/perubahan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perubahan" isHeader />
        <NavLink :activeItem="activeItem" header="Pembatalan" link="/app/pembatalan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="pembatalan" isHeader />
        <NavLink :activeItem="activeItem" header="Pencabutan" link="/app/pencabutan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="pencabutan" isHeader />
      </ul>

      <!-- ROLE: PEMOHON -->
      <ul class="nav" v-else-if="user.role === 'pemohon'">
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />

        <!-- <NavLink v-if="user.tipe_pemohon == 'pemerintah'" :activeItem="activeItem" header="Permohonan" link="/app/permohonan" iconName="flaticon-file" icon-img="sidebar/Outline/Document.svg" index="permohonan" :childrenLinks="[
          { header: 'Non Berusaha', link: '/app/permohonan/non-berusaha/pemerintah' },
        ]" /> -->

        <NavLink v-if="user.tipe_pemohon == 'pemerintah'" :activeItem="activeItem" header="Permohonan" link="/app/permohonan/non-berusaha/pemerintah" iconName="flaticon-file" index="permohonan" icon-img="sidebar/Outline/Document.svg" isHeader />

        <NavLink v-if="user.tipe_pemohon == 'swasta'" :activeItem="activeItem" header="Permohonan" link="/app/permohonan" iconName="flaticon-file" icon-img="sidebar/Outline/Document.svg" index="permohonan" :childrenLinks="[
          { header: 'Berusaha', link: '/app/permohonan/berusaha' },
          { header: 'Non Berusaha', link: '/app/permohonan/non-berusaha/swasta' },
        ]" />

        
        <NavLink :activeItem="activeItem" header="Pemutakhiran" link="/app/pemutakhiran" iconName="flaticon-document" index="pemutakhiran" icon-img="sidebar/Outline/Document.svg" isHeader />
        <NavLink :activeItem="activeItem" header="Laporan Tahunan" link="/app/laporan-tahunan" iconName="flaticon-search" index="laporan-tahunan" icon-img="sidebar/Fill/Search.svg" isHeader />
        
        <h5 class="navTitle first">LAINNYA</h5>
        <NavLink :activeItem="activeItem" header="Profil" link="/app/profil" iconName="flaticon-person" index="profil" icon-img="sidebar/Outline/User.svg" isHeader />
        <NavLink :activeItem="activeItem" header="Panduan" link="/app/panduan" iconName="flaticon-person" index="panduan" icon-img="sidebar/Outline/Stack.svg" isHeader />
      </ul>

      <!-- ROLE: BENDAHARA -->
      <ul class="nav" v-else-if="user.role == 'bendahara'">
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />
        
        <h5 class="navTitle">Perizinan Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Perizinan Baru" link="/app/perizinan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perizinan-baru" isHeader />
        <NavLink :activeItem="activeItem" header="Penambahan KBLI" link="/app/penambahan-kbli" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="penambahan-kbli" isHeader />

        <h5 class="navTitle">Perizinan Non Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Pemerintah" link="/app/nonberusaha/pemerintah" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-pemerintah" isHeader />
        <NavLink :activeItem="activeItem" header="Swasta" link="/app/nonberusaha/swasta" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-swasta" isHeader />
      </ul>
      <ul class="nav" v-else>
        <h5 class="navTitle first">APP</h5>
        <NavLink :activeItem="activeItem" header="Dashboard" link="/app/dashboard" iconName="flaticon-home" index="dashboard" icon-img="sidebar/Outline/Home.svg" isHeader />

        <h5 class="navTitle">Perizinan Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Perizinan Baru" link="/app/perizinan" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="perizinan-baru" isHeader />

        <h5 class="navTitle">Perizinan Non Berusaha</h5>
        <NavLink :activeItem="activeItem" header="Pemerintah" link="/app/nonberusaha/pemerintah" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-pemerintah" isHeader />
        <NavLink :activeItem="activeItem" header="Swasta" link="/app/nonberusaha/swasta" iconName="flaticon-documentation" icon-img="sidebar/Outline/Document.svg" index="nonberusaha-swasta" isHeader />

        <!-- <h5 class="navTitle">Pengendalian</h5>
        <NavLink :activeItem="activeItem" header="Penilaian Laporan Tahunan" link="/app/penilaian-laporan-tahunan" iconName="flaticon-search" index="penilaian-laporan-tahunan" icon-img="sidebar/Fill/Search.svg" isHeader class="custom-navlink" /> -->
      </ul>
    </nav>
  </div>
</template>

<style>
.custom-navlink a {
  line-height: 18px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
</style>

<script>
import { mapState, mapActions } from 'vuex'
import isScreen from '@/core/screenHelper'
import NavLink from './NavLink/NavLink'
import Swal from 'sweetalert2'
import toast from '../../helper/toast'
import axios from 'axios'

export default {
  name: 'Sidebar',
  components: { NavLink },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem('user') || '{}'),
      alerts: [
        {
          id: 0,
          title: 'Sales Report',
          value: 15,
          footer: 'Calculating x-axis bias... 65%',
          color: 'danger',
        },
        {
          id: 1,
          title: 'Personal Responsibility',
          value: 20,
          footer: 'Provide required notes',
          color: 'primary',
        },
      ],
    }
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive', 'switchSidebar']),
    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/')
      paths.pop()
      this.changeSidebarActive(paths.join('/'))
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(false)
        this.setActiveByRoute()
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(true)
        this.changeSidebarActive(null)
      }
    },
    async checkPemohon() {
      setTimeout(async () => {
        if (!this.user.tipe_pemohon && this.user.role == 'pemohon') {
          const { isConfirmed, isDenied, isDismissed } = await Swal.fire({
            title: "🚀 Perbaharuan Sistem Baru E-SEA!",
            html: `
              <div style="text-align: left;">
                <p>Kami telah memperbarui <b>Sistem E-SEA</b> ke versi terbaru. Kami perlu konfirmasi kategori pengguna Anda.</p>
              </div>
            `,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "Logout",
            cancelButtonColor: "#d01345",
            confirmButtonText: "Pemerintah",
            denyButtonText: "Swasta",
            showDenyButton: true,
            denyButtonColor: "#25b264",
            allowOutsideClick: false,
            allowEscapeKey: false,
          })

          if (isConfirmed) {
            this.updateUser("pemerintah")
          } else if (isDenied) {
            this.updateUser("swasta")
          } else if (isDismissed) {
            localStorage.clear()
            this.$router.push("/login")
          }
        }
      }, 1500)
    },

    updateUser(jenis){
      this.$loading(true)
      axios
        .post(
          this.baseapi + "api/user/" + this.user.id,
          {
            tipe_pemohon: jenis
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        ).then(() => {
          this.user.tipe_pemohon = jenis
          localStorage.setItem("user", JSON.stringify(this.user))
        }).catch(() => {
          toast.error(this, "Terjadi kesalahan")
        }).finally(() => {
          this.$loading(false)
        })
    }
  },
  created() {
    this.setActiveByRoute()
    if (this.$route.path === '/app/dashboard') {
      if (
        this.user.role === 'tim_penilai_pusat' ||
        this.user.role === 'tim_penilai_upt'
      ) {
        this.$router.push('/app/penilaian-laporan-tahunan')
      }
    }
    this.checkPemohon()
  },
  computed: {
    ...mapState('layout', {
      sidebarStatic: (state) => state.sidebarStatic,
      sidebarOpened: (state) => !state.sidebarClose,
      activeItem: (state) => state.sidebarActiveElement,
    }),
  },
}
</script>

<style src="./Sidebar.scss" lang="scss" scoped />